/**
 * DegreeEventsInline — small inline strip on degree pages showing
 * approved firm events tagged with this degree's subject area.
 * Renders up to 3 compact event cards + a "See all X events" link.
 * Silent when there are no matches.
 *
 * Extracted from pages/DegreeDetail.jsx (2026-02-04) to reduce bloat.
 */
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import EventCard from "@/components/app/EventCard";

export default function DegreeEventsInline({ subject }) {
  const [events, setEvents] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    if (!subject) return;
    api
      .get(`/events?subject=${encodeURIComponent(subject)}&limit=3`)
      .then((r) => setEvents(r.data.events || []))
      .catch(() => setEvents([]))
      .finally(() => setLoaded(true));
  }, [subject]);
  if (!loaded || events.length === 0) return null;
  return (
    <div className="mt-3 rounded-md border border-[#4C1D95]/20 bg-[#F5F0FF]/50 p-3" data-testid="degree-events-inline">
      <div className="text-[10px] font-underground-sc tracking-[0.18em] text-[#4C1D95] mb-2">
        {events.length} upcoming event{events.length === 1 ? "" : "s"} for {subject} candidates
      </div>
      <div className="space-y-1.5">
        {events.map((e) => <EventCard key={e.id} event={e} variant="compact" />)}
      </div>
      <div className="mt-2">
        <a
          href={`/events?subject=${encodeURIComponent(subject)}`}
          className="text-[11px] text-[#4C1D95] hover:text-[#3B0764] font-medium"
          data-testid="degree-events-inline-see-all"
        >
          See all {subject} events →
        </a>
      </div>
    </div>
  );
}
